import rules from "@assets/web-v3-images/icons/rules.png";

const RuleIcon = ({ width = 96, height = 96, className }) => (
  <img src={rules} alt="Rules" width={width} height={height} className={className} />
);

export default RuleIcon;
